<template>
  <v-alert color="white" class="text-align-center">
    <span class="table-no-results-text">
      <span v-if="noItems">
        <v-col
          class="title font-weight-bold mt-0 pt-sm-2 py-md-0 pl-md-0"
          cols="12"
        >
          <h2 v-if="filterCriteriaResults" class="subtitle-1 ma-0">
            <v-icon left color="primary">fas fa-times-circle</v-icon>
            <span class="font-weight-bold black--text"
              >{{ $t("baseFilters.results-pt1") }}&nbsp;</span
            >
            <span class="font-weight-bold secondary--text">{{
              totalItems
            }}</span>
            <span class="font-weight-bold black--text"
              >&nbsp;{{ $t("baseFilters.results-pt2") }}&nbsp;</span
            >
            <span class="font-weight-bold secondary--text">{{
              filterCriteriaResults
            }}</span>
            <span class="font-weight-bold black--text" v-if="activeSortValue"
              >&nbsp;{{ $t("baseFilters.results-pt5") }}&nbsp;</span
            >
            <span
              class="font-weight-bold secondary--text"
              v-if="activeSortValue"
            >
              {{ activeSortValue }}</span
            >
          </h2>
          <h2 v-else class="subtitle-1 ma-0">
            <v-icon left color="primary">fas fa-times-circle</v-icon>
            <span class="font-weight-bold black--text"
              >{{ $t("hfManagement.emptyData") }}&nbsp;</span
            >
          </h2>
        </v-col>
      </span>
    </span>
  </v-alert>
</template>

<script>
export default {
  props: {
    filterCriteriaResults: {
      type: String
    },
    activeSortValue: {
      type: String
    },
    totalItems: {
      type: Number
    }
  },
  computed: {
    noItems() {
      return this.totalItems === 0;
    }
  }
};
</script>
